import { render, staticRenderFns } from "./PconEditProd.vue?vue&type=template&id=6f995ea1&scoped=true&"
import script from "./PconEditProd.vue?vue&type=script&lang=js&"
export * from "./PconEditProd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f995ea1",
  null
  
)

export default component.exports